import { RefreshButton, TopToolbar } from 'ra-ui-materialui';
import { AVATARS, ROLE_BIG_CREATE_QUOTE, ROLE_BIG_UPDATE_DEMAND_STATUS } from '@/utils/CONST';
import { usePermissions } from 'react-admin';
import { Button, useUnselectAll } from 'react-admin';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

interface Props {
    action: 'create_quote' | 'status' | undefined;
    setAction: any;
    multiSelectionState: boolean;
    setMultiSelectionState: any;
}

const DisordersTreatmentListActions = ({
    multiSelectionState,
    setMultiSelectionState,
    setAction,
    action: selectedAction,
}: Props) => {
    const { permissions } = usePermissions();
    const unselectAll = useUnselectAll(AVATARS, 'disordersTreatmentList');

    const handleSetAction = (action: 'create_quote' | 'status') => {
        unselectAll();

        if (selectedAction === action) {
            setMultiSelectionState(!multiSelectionState);
            setAction(undefined);
        } else {
            setAction(action);
            if (!multiSelectionState) {
                setMultiSelectionState(true);
            }
        }
    };

    return (
        <TopToolbar>
            {permissions?.includes(ROLE_BIG_CREATE_QUOTE) && (
                <Button
                    variant={selectedAction === 'create_quote' ? 'contained' : 'text'}
                    label={'disorder.list.create_quote'}
                    onClick={() => handleSetAction('create_quote')}
                    // sx={{ justifyContent: 'flex-start', px: 2 }}
                >
                    <PlaylistAddIcon />
                </Button>
            )}

            {permissions?.includes(ROLE_BIG_UPDATE_DEMAND_STATUS) && (
                <Button
                    variant={selectedAction === 'status' ? 'contained' : 'text'}
                    label={'buttons.click_to_change_status'}
                    onClick={() => handleSetAction('status')}
                    // sx={{ justifyContent: 'flex-start', px: 2 }}
                >
                    <SyncAltIcon />
                </Button>
            )}

            <RefreshButton />
        </TopToolbar>
    );
};

export default DisordersTreatmentListActions;
